import { OAuthModuleConfig } from 'angular-oauth2-oidc';

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: ['https://idp.hermes-dev.xyz/api'],
    sendAccessToken: true,
  }
};
